import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { baseUrl, apiVersion } = CONFIG_VARS;

export const schoolsApi = createApi({
  reducerPath: "schoolsApi",
  baseQuery: createBaseQuery(baseUrl["1"], true), // Enable auth token
  endpoints: (builder) => ({
    getSchools: builder.query({
      query: (data) => ({
        url: `/${apiVersion}/onboarding/schools?page=${data.page}&limit=${
          data.limit
        }&search_query=${data.searchQuery || ""}`,
        method: "GET",
      }),
      // Disable caching to ensure loading state is always tracked
      keepUnusedDataFor: 0,
      // Force refetch on any parameter change
      forceRefetch: ({ currentArg, previousArg }) => {
        return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
      },
    }),
  }),
});

export const { useGetSchoolsQuery } = schoolsApi;
